PJQ.menus = {
	activeMenus: [],
	closeActiveMenus: function () {
		_.each(PJQ.menus.activeMenus, function (contextMenu) {
			contextMenu.close();
		});
	}
};

PJQ.menus.ContextMenu = PJQ.views.BaseView.extend({
	defaults: {

		/* user-defined function to obtain specific data about the currently
		 * opened element, to pass it to the rest of user-defined functions
		 * of an action. */
		fetchElementData: _.noop,

		/* what the source of the context menu should be when opened.
		 * Valid values are 'mouse' and 'element'. */
		menuSource: 'mouse',

		/* how to calculate the position of the context menu based on its source.
		 * Valid values are 'aboveLeft', 'aboveRight', 'belowLeft', and 'belowRight'. */
		menuPosition: 'belowLeft',

		/* the event to listen to open the menu.
		 * Valid values are 'click', 'right-click', 'hover' */
		menuEvent: 'right-click',

		/* group actions to render them next to each other, with a separator
		 * between each group. */
		actionsGroups: [],

		/* message to show when there are no actions to show in a menu
		 * (isShown() returned false on all actions) */
		noActionsMessage: 'No available actions',

		/* Hide the menu entirely if there are no available actions instead of displaying the message. */
		isHideNoActions: false,

		/* In some weird cases, another plugin may be installing 'click' listeners
		 * in the anchors used for each action of the context menu, and stopping
		 * the event bubbling before it reaches this plugin's listener.
		 *
		 * For those cases, _actionSelectEvent can be used to change the event we
		 * listen to, for example to 'mousedown'.
		 *
		 * Unless the context menu is not working due to this and a workaround is
		 * needed, this option can be safely ignored.
		 */
		_actionSelectEvent: 'click',

		/* In some situations such as datagrids that contain subgrids, the context menu needs to be wrapped in a fixed div to avoid display issues
		 *
		 */
		isWrapInFixedContainer: false,

		onOpen: _.noop,
		onClose: _.noop
	},
	events: {},
	beforeFirstRender: function () {
		// namespaces to use when registering event listeners
		this.namespace = _.uniqueId('.ContextMenu_');
		this.closeNamespace = _.uniqueId('.ContextMenuClose_');

		// jQuery object of the rendered context menu. Not part of the DOM yet.
		this.$menu = this.renderMenu(this);
		this.$menuList = this.$menu.children();

		/* append the context menu to <body> to be able to use "position: absolute"
		 * absolute to the whole window. */
		this.$menu.hide().appendTo(this.$el);

		/* the element in which the context menu was opened. Updated every time
		 * the menu is opened. */
		this.$openTarget = null;

		/* event that triggered the context menu to open. Updated every time
		 * the menu is opened. */
		this.openEvent = null;

		this.setupOpenEventListeners();

		this.setupActionsEventListeners();

		// keep track of all the existing context menu instances in the page
		PJQ.menus.activeMenus.push(this);

		return false;
	},
	updatePosition: function () {
		let menuLocation = null, // my
			relativeToElem = null, // of
			relativeToLocation = null; // at

		switch (this.options.menuSource) {
			case 'element':
				relativeToElem = this.$openTarget;
				break;
			case 'mouse':
				relativeToElem = this.openEvent;
				break;
			default:
				throw new Error("Unknown ContextMenu 'menuSource' option");
		}

		switch (this.options.menuPosition) {
			case 'belowRight':
				menuLocation = 'right top';
				relativeToLocation = 'right bottom';
				break;
			case 'belowLeft':
				menuLocation = 'left top';
				relativeToLocation = 'left bottom';
				break;
			case 'aboveRight':
				menuLocation = 'right bottom';
				relativeToLocation = 'right top';
				break;
			case 'aboveLeft':
				menuLocation = 'left bottom';
				relativeToLocation = 'left top';
				break;
			default:
				throw new Error("Unknown ContextMenu 'menuPosition' option");
		}

		// update the menu's height and width manually
		this.$menu.css({display: 'block'});

		// once the menu is not hidden anymore, we can obtain its content's height and width,
		// to manually update it in the menu
		this.$menu.css({
			height: this.$menuList.height(),
			width: this.$menuList.width()
		});

		this.$menu.position({my: menuLocation, at: relativeToLocation, of: relativeToElem});
	},
	open: function ($openTarget) {
		let self = this;

		// first close all open instances of opened context menus in the page
		PJQ.menus.closeActiveMenus();

		self.$openTarget = $openTarget;

		self.openEvent = event;

		let targetData = self.options.fetchElementData(self.$openTarget),
			$actions = self.$menu.find('[data-action]'),
			$noActionsMsg = self.$menu.find('.noActionsMessage');

		// clear previously hidden actions, and hide by default the 'No actions' message
		$actions.show();
		$noActionsMsg.hide();

		/* go through all actions to update the text to show, which ones to show
		 * enabled/disabled and which ones to hide. */
		let numShown = 0;
		$actions.each(function () {
			let $action = $(this),
				$actionName = $action.find('.actionName'),
				actionId = $action.data('action'),
				action = self.options.actions[actionId];

			let itemClasses = $action.attr('class');
			if (_.size(action.itemClasses) > 0) {
				itemClasses += (' ' + action.itemClasses);
			}

			if (action.isDanger) {
				itemClasses += (' ' + 'danger-item');
			}
			$action.attr('class', itemClasses);

			let textClasses = $actionName.attr('class');
			if (_.size(action.textClasses) > 0) {
				textClasses = textClasses + ' ' + action.textClasses;
			}
			$actionName.attr('class', textClasses);

			if (typeof action.isShown === 'function' && action.isShown(targetData) !== true) {
				$action.hide();
				return;
			}
			else {
				numShown++;
			}

			// the name provided for an action may be dynamic, provided as a function
			$actionName.html(
				_.isFunction(action.name) && action.name(targetData) || action.name
			);

			if (action.isEnabled && action.isEnabled(targetData) === false) {
				$action.addClass('disabled');
			}
		});

		if (numShown === 0) {
			$noActionsMsg.show();
		}

		// once it is known which actions are or arent being shown
		// (so we know the final height of the context menu),
		// calculate its position
		this.updatePosition();

		if (numShown === 0 && this.options.isHideNoActions)
			this.$menu.hide();
		else {
			this.$menu.show();

			this.setupCloseEventListeners();

			this.options.onOpen(targetData);
		}
	},
	close: function () {
		// hide the menu
		this.$menu.hide();

		this.clearCloseEventListeners();

		this.options.onClose();
	},
	destroy: function () {
		this.close();
		this.clearOpenEventListeners();
		this.clearActionsEventListeners();
	},
	renderMenu: function (_this) {
		let $menu = $('<div class="dropdown context-menu"/>'),
			$ul = $('<ul class="dropdown-menu"/>');

		// group all actions following the actionsGroups option, to
		// add a separator between each of them.
		let groups = [];

		// default group where all ungrouped actions will go
		groups[0] = [];

		// add the rest of groups
		_.each(_this.options.actionsGroups, function (groupArr, ind) {
			groups[ind + 1] = [];
		});

		// find out if any of the actions has an icon
		let actionsHaveIcon = false;

		// add each action to the group it belongs to, or the default group
		_.each(_this.options.actions, function (action, actionId) {
			let addedToGroup = false;

			_.each(_this.options.actionsGroups, function (groupArr, ind) {
				if (_.contains(groupArr, actionId)) {
					groups[ind + 1].push(actionId);
					addedToGroup = true;
				}
			});

			if (addedToGroup === false) {
				groups[0].push(actionId);
			}

			if (typeof action.iconClass !== 'undefined') {
				actionsHaveIcon = true;
			}
		});

		let isFirstNonEmptyGroup = true;
		_.each(groups, function (actionsIds) {
			if (actionsIds.length == 0)
				return;

			if (isFirstNonEmptyGroup === false) {
				$ul.append('<li class="divider"></li>');
			}
			isFirstNonEmptyGroup = false;

			_.each(actionsIds, function (actionId) {
				let action = _this.options.actions[actionId];
				if (typeof action.isHidden === 'function' && action.isHidden()) {
					return;
				}

				/* At least an action has an icon. Add the icon of the current action,
				 * or room to align it with the actions which do have one. */
				if (actionsHaveIcon === true) {
					$ul.append(
						'<li role="presentation" class="menu-item" data-action="' + actionId + '">' +
						'<a href="javascript:void(0)" role="menuitem" class="menu-item-link">' +
						'<i class="' + (action.iconClass || '') + '"></i> ' +
						'<span class="actionName"></span>' +
						'</a>' +
						'</li>'
					);
				}
				// neither of the actions have an icon.
				else {
					$ul.append(
						'<li role="presentation" class="menu-item" data-action="' + actionId + '">' +
						'<a href="javascript:void(0)" role="menuitem" class="menu-item-link"><span class="actionName"></span></a>' +
						'</li>'
					);
				}
			});

			$ul.append(
				'<li role="presentation" class="noActionsMessage disabled">' +
				'<a href="javascript:void(0)" role="menuitem">' +
				'<span>' + _this.options.noActionsMessage + '</span>' +
				'</a>' +
				'</li>'
			);
		});

		let result = $menu.append($ul);

		if (this.options.isWrapInFixedContainer) {
			let $wrapper = $('<div style="position:fixed;overflow:visible;width:100%;z-index:10000;"/>')
			result = $wrapper.append($menu);
		}

		return result;
	},
	setupOpenEventListeners: function () {
		let self = this,
			openEventName = null;

		switch (self.options.menuEvent) {
			case 'click':
				openEventName = 'click';
				break;
			case 'right-click':
				openEventName = 'contextmenu';
				break;
			case 'hover':
				openEventName = 'mouseenter';
				break;
			default:
				throw new Error("Unknown ContextMenu 'menuEvent' option");
		}

		// install the handler for every future elements where
		// the context menu will open
		self.$el.on(openEventName + self.namespace, self.options.selector, function (evt) {
			self.open($(this), evt);

			// cancel event propagation, to avoid it bubbling up to this.$el
			// and closing the context menu as if the user clicked outside the menu.
			return false;
		});
	},
	clearOpenEventListeners: function () {
		this.$el.off(this.namespace);
	},
	setupActionsEventListeners: function () {
		let self = this,
			actionSelectEvent = self.options._actionSelectEvent + self.namespace;

		// handler to run when an option is selected
		this.$menu.on(actionSelectEvent, function (evt) {
			evt.preventDefault();
			evt.stopPropagation();

			let $target = $(evt.target),
				$action = $target.closest('[data-action]');

			// check if the clicked element is an action, and its enabled.
			// if not don't do anything
			if (!$action || !$action.length || $action.is('.disabled')) {
				return;
			}

			let actionId = $action.data('action'),
				targetData = self.options.fetchElementData(self.$openTarget);

			/* call the user click handler. It receives the optional user-defined data,
			 * or undefined. */
			self.options.actions[actionId].onClick(targetData);

			// close the menu
			self.close();
		});
	},
	clearActionsEventListeners: function () {
		this.$menu.off(this.namespace);
	},
	setupCloseEventListeners: function () {
		let self = this;
		switch (self.options.menuEvent) {
			case 'click':
				break;
			case 'right-click':
				break;
			default:
				throw new Error("Unknown ContextMenu 'menuEvent' option");
		}

		// If the user clicks outside the context menu, close it.
		// Attach this event to the body to ensure it closes no matter where they click
		$('html').on('click' + self.closeNamespace, function () {
			self.close();
		});
	},
	clearCloseEventListeners: function () {
		this.$el.off(this.closeNamespace);
	}
});